module.exports = __webpack_public_path__ + "static/media/checklist.cdb12b68.png";